import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cms-newsletter',
  styleUrl: 'cms-newsletter.scss',
  shadow: true,
})
export class CmsNewsletter {
  /**
   * set the Headline
   */
  @Prop() newsletterHeadline: string;

  /**
   * set the subscribe button text
   */
  @Prop() buttonText: string;

  /**
   * set the url of the target page
   */
  @Prop() targetPageUrl: string;

  render() {
    return (
      <Host>
        <div class={'newsletter-inner'}>
          <div class={'headline-wrapper'}>
            <div class='icon-wrapper'>
              <cms-icon
                colorToken='--cms-semanticColors-base-strong-icon'
                size='xl'
                icon='mail'
              />
            </div>
            <div class={'newsletter-headline'}>
              {this.newsletterHeadline ? this.newsletterHeadline : null}
            </div>
          </div>
          <div class={'button-wrapper'}>
            <cms-button
              style={{
                '--cms-theme-text-color':
                  'var(--cms-semanticColors-base-strong-text)',
                '--cms-theme-border-color':
                  'var(--cms-semanticColors-base-strong-border)',
                '--cms-theme-svg-color':
                  'var(--cms-semanticColors-base-strong-icon)',
              }}
              class='newsletter-cta'
              tagTitle={this.newsletterHeadline ?? null}
              theme='secondary'
              size='button-md'
              href={this.targetPageUrl ?? null}
              rel='noopener'
              target='_self'
              label={this.buttonText ?? null}
              icon='arrowRight'
              icon-size='sm'
            />
          </div>
        </div>
      </Host>
    );
  }
}
